import React, { useEffect, useCallback, useState } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { LogTableWrapper, RunInstanceIdTitle } from './styled';
import tableColumns from './columns';
import { trmResources } from '../../../../../util/GlobalConstant';
import { hasAttributeValue } from '../../../../../util';

const DEFAULT_CURRENT_PAGE = 1;
const PAGE_SIZE = 10;

const ActivityLogTab = ({
  apiActions = {},
  runInstanceHistoryList,
  scenarioID,
  isLoading,
  trmActions,
  authentication
}) => {
  const { fetchRunInstanceHistory, fetchTypologiesActions } = apiActions;
  const [pagination, setPagination] = useState({
    page: DEFAULT_CURRENT_PAGE,
    pageSize: PAGE_SIZE
  });

  const preventionResourceAccess = hasAttributeValue(
    authentication,
    trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
    '24'
  );

  useEffect(() => {
    fetchRunInstanceHistory({
      scenarioID,
      ...pagination
    });

    if (preventionResourceAccess) {
      fetchTypologiesActions();
    }
  }, []);

  const onPaginationChange = useCallback((page, pageSize) => {
    setPagination({ page, pageSize });
    fetchRunInstanceHistory({
      scenarioID,
      page,
      pageSize
    });
  });

  const { instances = [], scenario } = runInstanceHistoryList || {};

  return (
    <>
      <RunInstanceIdTitle>{`Run Instance Id: ${scenario?.id}`}</RunInstanceIdTitle>
      <LogTableWrapper>
        <Table
          loading={isLoading}
          dataSource={instances?.payload}
          columns={tableColumns(trmActions, preventionResourceAccess)}
          pagination={{
            total: instances?.total,
            onChange: onPaginationChange,
            showTotal: (total) => `${total} Records`,
            ...pagination
          }}
        />
      </LogTableWrapper>
    </>
  );
};

ActivityLogTab.propTypes = {
  runInstanceHistoryList: PropTypes.object,
  apiActions: PropTypes.object,
  scenarioID: PropTypes.string,
  isLoading: PropTypes.bool
};

export default ActivityLogTab;
